/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV3ServiceListPushHistoryGet } from '../fn/push/api-v-3-service-list-push-history-get';
import { ApiV3ServiceListPushHistoryGet$Params } from '../fn/push/api-v-3-service-list-push-history-get';
import { apiV3ServiceListPushHistoryGet$Plain } from '../fn/push/api-v-3-service-list-push-history-get-plain';
import { ApiV3ServiceListPushHistoryGet$Plain$Params } from '../fn/push/api-v-3-service-list-push-history-get-plain';
import { ListPushHistoryResponseApiFrom } from '../models/list-push-history-response-api-from';

@Injectable({ providedIn: 'root' })
export class ApiFromPushService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV3ServiceListPushHistoryGet()` */
  static readonly ApiV3ServiceListPushHistoryGetPath = '/api/v3/service/ListPushHistory';

  /**
   * Getting the history of sending PUSH messages.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceListPushHistoryGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListPushHistoryGet$Plain$Response(params?: ApiV3ServiceListPushHistoryGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ListPushHistoryResponseApiFrom>>> {
    return apiV3ServiceListPushHistoryGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting the history of sending PUSH messages.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceListPushHistoryGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListPushHistoryGet$Plain(params?: ApiV3ServiceListPushHistoryGet$Plain$Params, context?: HttpContext): Observable<Array<ListPushHistoryResponseApiFrom>> {
    return this.apiV3ServiceListPushHistoryGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ListPushHistoryResponseApiFrom>>): Array<ListPushHistoryResponseApiFrom> => r.body)
    );
  }

  /**
   * Getting the history of sending PUSH messages.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceListPushHistoryGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListPushHistoryGet$Response(params?: ApiV3ServiceListPushHistoryGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ListPushHistoryResponseApiFrom>>> {
    return apiV3ServiceListPushHistoryGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting the history of sending PUSH messages.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceListPushHistoryGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceListPushHistoryGet(params?: ApiV3ServiceListPushHistoryGet$Params, context?: HttpContext): Observable<Array<ListPushHistoryResponseApiFrom>> {
    return this.apiV3ServiceListPushHistoryGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ListPushHistoryResponseApiFrom>>): Array<ListPushHistoryResponseApiFrom> => r.body)
    );
  }

}
